/**
 * Source Han Serif CN
 * Font Weight: 400
 */
export default {
    fontFamily: 'Source Han Serif',
    fontWeight: 400,
    fontStyle: 'normal',
    unitsPerEm: 1000,
    metrics: {
        ascender: 1151,
        descender: -286,
        lineGap: 0,
    },
    glyphs: {
        ' ': 258,
        '\t': 258,
        '\n': 258,
        '\r': 258,
        '!': 303,
        '"': 367,
        '#': 567,
        '%': 935,
        '&': 780,
        '\'': 189,
        '(': 361,
        ')': 361,
        '*': 479,
        '+': 576,
        ',': 326,
        '-': 338,
        '.': 326,
        '/': 348,
        ':': 326,
        ';': 326,
        '<': 576,
        '=': 576,
        '>': 576,
        '?': 438,
        '@': 901,
        'B': 675,
        'C': 690,
        'D': 772,
        'E': 655,
        'F': 629,
        'G': 742,
        'H': 859,
        'I': 401,
        'J': 402,
        'K': 723,
        'L': 640,
        'M': 979,
        'N': 798,
        'P': 637,
        'R': 707,
        'S': 557,
        'T': 653,
        'V': 726,
        'W': 1047,
        'X': 702,
        'Y': 688,
        'Z': 599,
        '[': 341,
        '\\': 348,
        ']': 341,
        '^': 576,
        '_': 555,
        '`': 435,
        'b': 627,
        'c': 529,
        'd': 617,
        'e': 549,
        'f': 385,
        'g': 560,
        'h': 655,
        'i': 325,
        'j': 301,
        'k': 592,
        'l': 324,
        'm': 976,
        'n': 658,
        'p': 630,
        'q': 602,
        'r': 454,
        's': 470,
        't': 354,
        'v': 546,
        'w': 829,
        'x': 564,
        'y': 551,
        'z': 496,
        '{': 375,
        '|': 270,
        '}': 375,
        '~': 576,
        '¡': 303,
        '¤': 542,
        '¦': 270,
        '¨': 435,
        '©': 822,
        'ª': 376,
        '«': 524,
        '¬': 576,
        '®': 498,
        '¯': 435,
        '°': 350,
        '²': 395,
        '³': 395,
        '´': 435,
        'µ': 619,
        '·': 326,
        '¸': 435,
        '¹': 395,
        'º': 404,
        '»': 524,
        '¼': 935,
        '½': 935,
        '¾': 935,
        '¿': 438,
        'Æ': 997,
        'Ç': 690,
        'È': 655,
        'É': 655,
        'Ê': 655,
        'Ë': 655,
        'Ì': 401,
        'Í': 401,
        'Î': 401,
        'Ï': 401,
        'Ð': 772,
        'Ñ': 798,
        'Ý': 688,
        'Þ': 659,
        'ß': 636,
        'æ': 852,
        'ç': 529,
        'è': 549,
        'é': 549,
        'ê': 549,
        'ë': 549,
        'ì': 325,
        'í': 325,
        'î': 325,
        'ï': 325,
        'ð': 591,
        'ñ': 658,
        'ý': 551,
        'þ': 608,
        'ÿ': 551,
        'Đ': 772,
        'đ': 617,
        'Ē': 655,
        'ē': 549,
        'Ě': 655,
        'ě': 549,
        'Ĩ': 401,
        'ĩ': 325,
        'Ī': 401,
        'ī': 325,
        'Ń': 798,
        'ń': 658,
        'Ň': 798,
        'ň': 658,
        'Œ': 1012,
        'œ': 949,
        'Ǐ': 401,
        'ǐ': 325,
        'Ǹ': 798,
        'ǹ': 658,
        'Β': 675,
        'Γ': 608,
        'Δ': 688,
        'Ε': 655,
        'Ζ': 599,
        'Η': 859,
        'Ι': 401,
        'Κ': 723,
        'Λ': 716,
        'Μ': 979,
        'Ν': 798,
        'Ξ': 636,
        'Π': 844,
        'Ρ': 637,
        'Σ': 591,
        'Τ': 653,
        'Υ': 688,
        'Φ': 770,
        'Χ': 702,
        'Ψ': 822,
        'Ω': 797,
        'α': 604,
        'β': 616,
        'γ': 529,
        'δ': 565,
        'ε': 455,
        'ζ': 450,
        'ι': 303,
        'κ': 571,
        'λ': 570,
        'μ': 619,
        'ν': 529,
        'ξ': 471,
        'ο': 563,
        'π': 645,
        'ρ': 591,
        'ς': 495,
        'σ': 636,
        'τ': 522,
        'υ': 586,
        'φ': 754,
        'χ': 527,
        'ψ': 776,
        'ω': 788,
        '‒': 555,
        '—': 882,
        '‚': 229,
        '„': 436,
        '′': 265,
        '″': 449,
        '‹': 309,
        '›': 309,
        '‼': 584,
        '⁇': 832,
        '⁉': 713,
        'ℓ': 495,
        '№': 1089,
        '™': 780,
        '℮': 870,
        '−': 576,
        '✓': 646,
        '〪': 0,
        '〫': 0,
        '〬': 0,
        '〭': 0,
        '〮': 250,
        '〯': 250,
        '゙': 0,
        '゚': 0,
    },
    glyphsByWidth: {
        500: ' ｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟﾡﾢﾣﾤﾥﾦﾧﾨﾩﾪﾫﾬﾭﾮﾯﾰﾱﾲﾳﾴﾵﾶﾷﾸﾹﾺﾻﾼﾽﾾￂￃￄￅￆￇￊￋￌￍￎￏￒￓￔￕￖￗￚￛￜ￨￩￪￫￬￭￮',
        539: '$0123456789¢£¥ƒ₩₫€',
        552: 'aàáâãäåāăǎθ',
        594: 'oòóôõöøōŏơǒη',
        639: 'uùúûüũūŭưǔǖǘǚǜ',
        719: 'AÀÁÂÃÄÅĀĂǍΑ⁈',
        769: 'OQÒÓÔÕÖØŌŎƠǑΘΟ',
        792: 'UÙÚÛÜŨŪŬƯǓǕǗǙǛ',
        966: 'ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ',
    },
    defaultWidth: 1000,
    kerning: {
        '",': -114,
        '".': -114,
        '"/': -86,
        '"A': -133,
        '"C': -27,
        '"G': -27,
        '"J': -10,
        '"O': -27,
        '"Q': -27,
        '"S': -10,
        '"T': 32,
        '"U': -4,
        '"a': -32,
        '"c': -43,
        '"d': -43,
        '"e': -43,
        '"f': -5,
        '"g': -56,
        '"m': -8,
        '"n': -8,
        '"o': -43,
        '"p': -19,
        '"q': -43,
        '"r': -8,
        '"s': -32,
        '"z': -10,
        '#/': -32,
        '#A': -41,
        '#C': 14,
        '#G': 14,
        '#O': 14,
        '#Q': 14,
        '#V': -21,
        '#W': -21,
        '#Y': -5,
        '#f': -5,
        '#g': -7,
        '#t': 10,
        '#v': 5,
        '#w': 5,
        '#y': 5,
        '&)': -21,
        '&,': -7,
        '&-': -25,
        '&.': -7,
        '&J': -8,
        '&T': -59,
        '&U': -30,
        '&V': -68,
        '&W': -63,
        '&Y': -63,
        '&]': -21,
        '&c': -10,
        '&d': -10,
        '&e': -10,
        '&o': -10,
        '&q': -10,
        '&}': -21,
        '\',': -114,
        '\'.': -114,
        '\'/': -86,
        '\'A': -133,
        '\'C': -27,
        '\'G': -27,
        '\'J': -10,
        '\'O': -27,
        '\'Q': -27,
        '\'S': -10,
        '\'T': 32,
        '\'U': -4,
        '\'a': -32,
        '\'c': -43,
        '\'d': -43,
        '\'e': -43,
        '\'f': -5,
        '\'g': -56,
        '\'m': -8,
        '\'n': -8,
        '\'o': -43,
        '\'p': -19,
        '\'q': -43,
        '\'r': -8,
        '\'s': -32,
        '\'z': -10,
        '(#': -21,
        '(&': -21,
        '((': -54,
        '()': 13,
        '(-': -43,
        '(:': -43,
        '(;': -43,
        '(A': -32,
        '(C': -21,
        '(G': -21,
        '(J': 36,
        '(O': -21,
        '(Q': -21,
        '(S': -10,
        '(U': -10,
        '([': -54,
        '(]': 13,
        '(c': -30,
        '(d': -30,
        '(e': -30,
        '(f': -5,
        '(j': 106,
        '(m': -16,
        '(n': -16,
        '(o': -30,
        '(q': -30,
        '(r': -16,
        '(s': -21,
        '(t': -10,
        '(u': -23,
        '(v': -21,
        '(w': -21,
        '(x': -10,
        '(y': 16,
        '(z': -10,
        '({': -54,
        '(}': 13,
        '))': -54,
        '),': -43,
        ').': -43,
        ')A': -31,
        ')T': -21,
        ')U': -21,
        ')V': -53,
        ')W': -43,
        ')X': -21,
        ')Y': -43,
        ')]': -54,
        ')}': -54,
        '*,': -108,
        '*.': -108,
        '*A': -122,
        '*C': -10,
        '*G': -10,
        '*J': -21,
        '*O': -10,
        '*Q': -10,
        '*T': 23,
        '*X': -7,
        '*a': -41,
        '*c': -27,
        '*d': -27,
        '*e': -27,
        '*f': -8,
        '*g': -46,
        '*m': -7,
        '*n': -7,
        '*o': -27,
        '*p': -10,
        '*q': -27,
        '*r': -7,
        '*s': -25,
        '*z': -14,
        ',"': -86,
        ',\'': -86,
        ',(': -54,
        ',)': -48,
        ',*': -141,
        ',-': -43,
        ',C': -59,
        ',G': -59,
        ',O': -59,
        ',Q': -59,
        ',T': -86,
        ',U': -65,
        ',V': -144,
        ',W': -128,
        ',Y': -127,
        ',[': -54,
        ',\\': -141,
        ',]': -48,
        ',a': -21,
        ',c': -32,
        ',d': -32,
        ',e': -32,
        ',g': -21,
        ',j': 8,
        ',o': -32,
        ',p': -32,
        ',q': -32,
        ',s': -16,
        ',t': -43,
        ',u': -45,
        ',v': -97,
        ',w': -97,
        ',y': -43,
        ',z': -21,
        ',{': -54,
        ',}': -48,
        '-)': -43,
        '-,': -53,
        '-.': -53,
        '-/': -32,
        '-A': -32,
        '-C': 10,
        '-G': 10,
        '-J': -21,
        '-M': -10,
        '-N': -10,
        '-O': 10,
        '-Q': 10,
        '-T': -44,
        '-U': -10,
        '-V': -85,
        '-W': -75,
        '-X': -43,
        '-Y': -76,
        '-Z': -10,
        '-\\': -43,
        '-]': -43,
        '-b': -3,
        '-c': 10,
        '-d': 10,
        '-e': 10,
        '-f': -7,
        '-g': 5,
        '-h': -3,
        '-k': -3,
        '-l': -3,
        '-o': 10,
        '-q': 10,
        '-v': -7,
        '-w': -7,
        '-x': -21,
        '-y': -8,
        '-}': -43,
        '."': -86,
        '.\'': -86,
        '.(': -54,
        '.)': -48,
        '.*': -141,
        '.-': -43,
        '.C': -59,
        '.G': -59,
        '.O': -59,
        '.Q': -59,
        '.T': -86,
        '.U': -65,
        '.V': -144,
        '.W': -128,
        '.Y': -127,
        '.[': -54,
        '.\\': -141,
        '.]': -48,
        '.a': -21,
        '.c': -32,
        '.d': -32,
        '.e': -32,
        '.g': -21,
        '.j': 8,
        '.o': -32,
        '.p': -32,
        '.q': -32,
        '.s': -16,
        '.t': -43,
        '.u': -45,
        '.v': -97,
        '.w': -97,
        '.y': -43,
        '.z': -21,
        '.{': -54,
        '.}': -48,
        '/#': -21,
        '/,': -148,
        '/-': -65,
        '/.': -148,
        '//': -82,
        '/A': -76,
        '/T': 5,
        '/V': 13,
        '/W': 13,
        '/a': -35,
        '/c': -32,
        '/d': -32,
        '/e': -32,
        '/g': -35,
        '/m': -19,
        '/n': -19,
        '/o': -32,
        '/p': -19,
        '/q': -32,
        '/r': -19,
        '/s': -21,
        '/u': -14,
        '/x': -10,
        '/z': -21,
        ':T': -5,
        ':U': -10,
        ':V': -32,
        ':W': -32,
        ':X': -7,
        ':Y': -54,
        ':c': -3,
        ':d': -3,
        ':e': -3,
        ':o': -3,
        ':q': -3,
        ';T': -5,
        ';U': -10,
        ';V': -32,
        ';W': -32,
        ';X': -7,
        ';Y': -54,
        ';c': -3,
        ';d': -3,
        ';e': -3,
        ';o': -3,
        ';q': -3,
        '?)': -33,
        '?,': -121,
        '?.': -121,
        '?/': -76,
        '?]': -33,
        '?}': -33,
        '@,': -16,
        '@.': -16,
        '@A': -6,
        '@C': 5,
        '@G': 5,
        '@O': 5,
        '@Q': 5,
        '@V': -3,
        '@W': -3,
        '@X': -3,
        '@Y': -5,
        '@_': -86,
        '@b': -13,
        '@f': -5,
        '@g': -10,
        '@h': -13,
        '@k': -13,
        '@l': -13,
        '@p': -8,
        '@y': 5,
        'A"': -122,
        'A\'': -122,
        'A(': -20,
        'A)': -32,
        'A*': -117,
        'A-': -34,
        'AA': 10,
        'AB': -10,
        'AC': -38,
        'AD': -10,
        'AE': -10,
        'AF': -10,
        'AG': -38,
        'AH': -10,
        'AI': -10,
        'AJ': -13,
        'AK': -10,
        'AL': -10,
        'AM': -7,
        'AN': -7,
        'AO': -38,
        'AP': -10,
        'AQ': -38,
        'AR': -10,
        'AT': -63,
        'AU': -72,
        'AV': -132,
        'AW': -108,
        'AY': -97,
        'A[': -20,
        'A\\': -65,
        'A]': -32,
        'Aa': -4,
        'Ac': -19,
        'Ad': -19,
        'Ae': -19,
        'Ag': -3,
        'Aj': -8,
        'Ao': -19,
        'Ap': -30,
        'Aq': -19,
        'At': -21,
        'Au': -21,
        'Av': -57,
        'Aw': -57,
        'Ay': -48,
        'A{': -20,
        'A}': -32,
        'B"': -21,
        'B\'': -21,
        'B)': -16,
        'B*': -10,
        'B,': -29,
        'B.': -29,
        'B/': -19,
        'BA': -32,
        'BB': -27,
        'BC': -7,
        'BD': -27,
        'BE': -27,
        'BF': -27,
        'BG': -7,
        'BH': -27,
        'BI': -27,
        'BJ': -11,
        'BK': -27,
        'BL': -27,
        'BM': -16,
        'BN': -16,
        'BO': -7,
        'BP': -27,
        'BQ': -7,
        'BR': -27,
        'BT': -21,
        'BU': -32,
        'BV': -54,
        'BW': -40,
        'BX': -32,
        'BY': -54,
        'BZ': -7,
        'B\\': -16,
        'B]': -16,
        'B_': -27,
        'Bb': -10,
        'Bf': -16,
        'Bh': -10,
        'Bk': -10,
        'Bl': -10,
        'Bp': -10,
        'Bu': -16,
        'Bv': -18,
        'Bw': -18,
        'Bx': -10,
        'By': -8,
        'B}': -16,
        'C"': 21,
        'C\'': 21,
        'C)': 3,
        'C*': 3,
        'C@': 5,
        'CU': -10,
        'CV': -10,
        'CW': -10,
        'CY': -21,
        'C]': 3,
        'C_': -7,
        'Cp': -10,
        'Cu': -10,
        'C}': 3,
        'D"': -3,
        'D\'': -3,
        'D)': -21,
        'D,': -45,
        'D-': 3,
        'D.': -45,
        'D/': -30,
        'D@': 16,
        'DA': -57,
        'DB': -28,
        'DC': 10,
        'DD': -28,
        'DE': -28,
        'DF': -28,
        'DG': 10,
        'DH': -28,
        'DI': -28,
        'DJ': -10,
        'DK': -28,
        'DL': -28,
        'DM': -21,
        'DN': -21,
        'DO': 10,
        'DP': -28,
        'DQ': 10,
        'DR': -28,
        'DT': -19,
        'DU': -21,
        'DV': -48,
        'DW': -51,
        'DX': -43,
        'DY': -65,
        'DZ': -8,
        'D\\': -16,
        'D]': -21,
        'D_': -76,
        'Db': -10,
        'Dg': -10,
        'Dh': -10,
        'Dk': -10,
        'Dl': -10,
        'Dp': -10,
        'Ds': -10,
        'Dx': -10,
        'D}': -21,
        'EU': -15,
        'EV': -15,
        'EW': -15,
        'EY': -15,
        'Eg': -7,
        'Ep': -19,
        'Eu': -10,
        'Ev': -19,
        'Ew': -19,
        'Ey': -21,
        'F"': 13,
        'F&': -8,
        'F\'': 13,
        'F(': -10,
        'F*': 10,
        'F,': -103,
        'F-': -21,
        'F.': -103,
        'F/': -65,
        'F:': -5,
        'F;': -5,
        'F@': -22,
        'FA': -77,
        'FB': -10,
        'FC': -9,
        'FD': -10,
        'FE': -10,
        'FF': -10,
        'FG': -9,
        'FH': -10,
        'FI': -10,
        'FK': -10,
        'FL': -10,
        'FO': -9,
        'FP': -10,
        'FQ': -9,
        'FR': -10,
        'FT': 10,
        'F[': -10,
        'F\\': 14,
        'F_': -130,
        'Fa': -43,
        'Fb': -3,
        'Fc': -46,
        'Fd': -46,
        'Fe': -46,
        'Ff': -30,
        'Fg': -67,
        'Fh': -3,
        'Fi': -8,
        'Fk': -3,
        'Fl': -3,
        'Fm': -21,
        'Fn': -21,
        'Fo': -46,
        'Fp': -43,
        'Fq': -46,
        'Fr': -21,
        'Fs': -47,
        'Fu': -21,
        'Fv': -21,
        'Fw': -21,
        'Fx': -32,
        'Fy': -21,
        'Fz': -32,
        'F{': -10,
        'G(': 10,
        'G)': -5,
        'G,': -8,
        'G-': 23,
        'G.': -8,
        'G/': -16,
        'G@': 13,
        'GA': -10,
        'GB': -8,
        'GC': 10,
        'GD': -8,
        'GE': -8,
        'GF': -8,
        'GG': 10,
        'GH': -8,
        'GI': -8,
        'GK': -8,
        'GL': -8,
        'GO': 10,
        'GP': -8,
        'GQ': 10,
        'GR': -8,
        'GT': -8,
        'GU': -15,
        'GV': -38,
        'GW': -38,
        'GX': -19,
        'GY': -48,
        'GZ': -8,
        'G[': 10,
        'G]': -5,
        'G_': -41,
        'Gp': -10,
        'G{': 10,
        'G}': -5,
        'HC': -23,
        'HG': -23,
        'HO': -23,
        'HQ': -23,
        'Ha': -21,
        'Hc': -25,
        'Hd': -25,
        'He': -25,
        'Hf': -18,
        'Hg': -18,
        'Ho': -25,
        'Hp': -34,
        'Hq': -25,
        'Hs': -21,
        'Ht': -10,
        'Hu': -25,
        'Hv': -40,
        'Hw': -40,
        'Hy': -30,
        'IC': -23,
        'IG': -23,
        'IO': -23,
        'IQ': -23,
        'Ia': -21,
        'Ic': -25,
        'Id': -25,
        'Ie': -25,
        'If': -18,
        'Ig': -18,
        'Io': -25,
        'Ip': -34,
        'Iq': -25,
        'Is': -21,
        'It': -10,
        'Iu': -25,
        'Iv': -40,
        'Iw': -40,
        'Iy': -30,
        'J,': -57,
        'J-': -10,
        'J.': -57,
        'J/': -30,
        'J:': -23,
        'J;': -23,
        'J@': -14,
        'JA': -41,
        'JC': -10,
        'JG': -10,
        'JO': -10,
        'JQ': -10,
        'JS': -8,
        'J_': -79,
        'Ja': -26,
        'Jc': -25,
        'Jd': -25,
        'Je': -25,
        'Jf': -40,
        'Jg': -32,
        'Ji': -8,
        'Jj': -8,
        'Jm': -27,
        'Jn': -27,
        'Jo': -25,
        'Jp': -41,
        'Jq': -25,
        'Jr': -27,
        'Js': -30,
        'Jt': -19,
        'Ju': -32,
        'Jv': -32,
        'Jw': -32,
        'Jx': -21,
        'Jy': -30,
        'Jz': -21,
        'K-': -32,
        'KA': 10,
        'KC': -30,
        'KG': -30,
        'KJ': -16,
        'KO': -30,
        'KQ': -30,
        'KU': -10,
        'KV': -8,
        'KW': -8,
        'KY': -10,
        'KZ': 8,
        'Ka': -8,
        'Kc': -21,
        'Kd': -21,
        'Ke': -21,
        'Kg': -10,
        'Ko': -21,
        'Kp': -30,
        'Kq': -21,
        'Kt': -21,
        'Ku': -21,
        'Kv': -59,
        'Kw': -59,
        'Ky': -52,
        'L"': -141,
        'L\'': -141,
        'L)': -27,
        'L*': -108,
        'LB': -18,
        'LC': -16,
        'LD': -18,
        'LE': -18,
        'LF': -18,
        'LG': -16,
        'LH': -18,
        'LI': -18,
        'LJ': -18,
        'LK': -18,
        'LL': -18,
        'LM': -7,
        'LN': -7,
        'LO': -16,
        'LP': -18,
        'LQ': -16,
        'LR': -18,
        'LS': -16,
        'LT': -77,
        'LU': -48,
        'LV': -117,
        'LW': -101,
        'LX': -16,
        'LY': -108,
        'LZ': -16,
        'L\\': -59,
        'L]': -27,
        'Lf': -7,
        'Lp': -18,
        'Lt': -8,
        'Lu': -22,
        'Lv': -41,
        'Lw': -41,
        'Ly': -32,
        'L}': -27,
        'MC': -23,
        'MG': -23,
        'MO': -23,
        'MQ': -23,
        'Ma': -21,
        'Mc': -25,
        'Md': -25,
        'Me': -25,
        'Mf': -18,
        'Mg': -18,
        'Mo': -25,
        'Mp': -34,
        'Mq': -25,
        'Ms': -21,
        'Mt': -10,
        'Mu': -25,
        'Mv': -40,
        'Mw': -40,
        'My': -30,
        'N,': -32,
        'N-': -3,
        'N.': -32,
        'N/': -33,
        'N:': -14,
        'N;': -14,
        'NA': -39,
        'NB': -8,
        'NC': -17,
        'ND': -8,
        'NE': -8,
        'NF': -8,
        'NG': -17,
        'NH': -8,
        'NI': -8,
        'NK': -8,
        'NL': -8,
        'NO': -17,
        'NP': -8,
        'NQ': -17,
        'NR': -8,
        'NS': -8,
        'NU': -10,
        'NX': -10,
        'NZ': -3,
        'N_': -59,
        'Na': -14,
        'Nc': -11,
        'Nd': -11,
        'Ne': -11,
        'Nf': -21,
        'Ng': -21,
        'Nm': -10,
        'Nn': -10,
        'No': -11,
        'Np': -22,
        'Nq': -11,
        'Nr': -10,
        'Ns': -11,
        'Nt': -10,
        'Nu': -21,
        'Nv': -21,
        'Nw': -21,
        'Nx': -19,
        'Ny': -21,
        'Nz': -21,
        'O"': -27,
        'O\'': -27,
        'O)': -21,
        'O*': -10,
        'O,': -43,
        'O-': 10,
        'O.': -43,
        'O/': -21,
        'O@': 21,
        'OA': -38,
        'OB': -23,
        'OC': 10,
        'OD': -23,
        'OE': -23,
        'OF': -23,
        'OG': 10,
        'OH': -23,
        'OI': -23,
        'OJ': -8,
        'OK': -23,
        'OL': -23,
        'OM': -16,
        'ON': -16,
        'OO': 10,
        'OP': -23,
        'OQ': 10,
        'OR': -23,
        'OT': -8,
        'OU': -19,
        'OV': -38,
        'OW': -29,
        'OX': -32,
        'OY': -43,
        'O\\': -7,
        'O]': -21,
        'O_': -59,
        'O}': -21,
        'P"': 10,
        'P&': -6,
        'P\'': 10,
        'P)': -9,
        'P*': 23,
        'P,': -111,
        'P-': -5,
        'P.': -111,
        'P/': -54,
        'P:': 8,
        'P;': 8,
        'PA': -66,
        'PB': -10,
        'PD': -10,
        'PE': -10,
        'PF': -10,
        'PH': -10,
        'PI': -10,
        'PJ': -10,
        'PK': -10,
        'PL': -10,
        'PP': -10,
        'PR': -10,
        'PS': 7,
        'PT': 10,
        'PU': -21,
        'PV': -10,
        'PW': -10,
        'PX': -21,
        'PY': -23,
        'PZ': 10,
        'P\\': 10,
        'P]': -9,
        'P_': -155,
        'Pa': -5,
        'Pb': -3,
        'Pc': -21,
        'Pd': -21,
        'Pe': -21,
        'Pg': -21,
        'Ph': -3,
        'Pk': -3,
        'Pl': -3,
        'Pm': -7,
        'Pn': -7,
        'Po': -21,
        'Pq': -21,
        'Pr': -7,
        'Ps': -3,
        'Pt': 16,
        'Pv': 8,
        'Pw': 8,
        'Py': 16,
        'P}': -9,
        'Q"': -27,
        'Q\'': -27,
        'Q)': -21,
        'Q*': -10,
        'Q,': -43,
        'Q-': 10,
        'Q.': -43,
        'Q/': -21,
        'Q@': 21,
        'QA': -38,
        'QB': -23,
        'QC': 10,
        'QD': -23,
        'QE': -23,
        'QF': -23,
        'QG': 10,
        'QH': -23,
        'QI': -23,
        'QJ': -8,
        'QK': -23,
        'QL': -23,
        'QM': -16,
        'QN': -16,
        'QO': 10,
        'QP': -23,
        'QQ': 10,
        'QR': -23,
        'QT': -8,
        'QU': -19,
        'QV': -38,
        'QW': -29,
        'QX': -32,
        'QY': -43,
        'Q\\': -7,
        'Q]': -21,
        'Q_': -59,
        'Q}': -21,
        'R"': -43,
        'R\'': -43,
        'R*': -14,
        'R-': -16,
        'RA': 10,
        'RC': -20,
        'RG': -20,
        'RJ': -10,
        'RO': -20,
        'RQ': -20,
        'RT': -32,
        'RU': -35,
        'RV': -59,
        'RW': -52,
        'RX': 7,
        'RY': -52,
        'RZ': 7,
        'R\\': -21,
        'R_': 18,
        'Rc': -10,
        'Rd': -10,
        'Re': -10,
        'Ro': -10,
        'Rp': -14,
        'Rq': -10,
        'Rt': -10,
        'Ru': -14,
        'Rv': -21,
        'Rw': -21,
        'Ry': -21,
        'S)': -10,
        'S,': -21,
        'S.': -21,
        'S/': -16,
        'S@': 5,
        'SA': -19,
        'SB': -7,
        'SD': -7,
        'SE': -7,
        'SF': -7,
        'SH': -7,
        'SI': -7,
        'SJ': -8,
        'SK': -7,
        'SL': -7,
        'SM': -7,
        'SN': -7,
        'SP': -7,
        'SR': -7,
        'SS': -8,
        'ST': -10,
        'SU': -27,
        'SV': -29,
        'SW': -27,
        'SX': -10,
        'SY': -32,
        'S]': -10,
        'S_': -43,
        'Sb': -7,
        'Sf': -16,
        'Sg': -7,
        'Sh': -7,
        'Sk': -7,
        'Sl': -7,
        'Sp': -10,
        'St': -10,
        'Su': -10,
        'Sv': -19,
        'Sw': -19,
        'Sx': -8,
        'Sy': -19,
        'S}': -10,
        'T"': 32,
        'T\'': 32,
        'T(': -21,
        'T*': 23,
        'T,': -86,
        'T-': -44,
        'T.': -86,
        'T/': -50,
        'T:': -5,
        'T;': -5,
        'T@': -21,
        'TA': -70,
        'TC': -8,
        'TG': -8,
        'TO': -8,
        'TQ': -8,
        'TT': 10,
        'TU': -10,
        'TX': -3,
        'TZ': 7,
        'T[': -21,
        'T\\': 27,
        'T_': -88,
        'Ta': -43,
        'Tc': -73,
        'Td': -73,
        'Te': -73,
        'Tf': -10,
        'Tg': -43,
        'Tm': -32,
        'Tn': -32,
        'To': -73,
        'Tp': -72,
        'Tq': -73,
        'Tr': -32,
        'Ts': -54,
        'Tu': -30,
        'Tv': -43,
        'Tw': -43,
        'Tx': -38,
        'Ty': -43,
        'Tz': -65,
        'T{': -21,
        'U&': -14,
        'U(': -21,
        'U)': -10,
        'U,': -86,
        'U-': -14,
        'U.': -86,
        'U/': -60,
        'U:': -14,
        'U;': -14,
        'UA': -79,
        'UB': -21,
        'UC': -28,
        'UD': -21,
        'UE': -21,
        'UF': -21,
        'UG': -28,
        'UH': -21,
        'UI': -21,
        'UJ': -15,
        'UK': -21,
        'UL': -21,
        'UM': -10,
        'UN': -10,
        'UO': -28,
        'UP': -21,
        'UQ': -28,
        'UR': -21,
        'US': -19,
        'UT': -10,
        'UU': -21,
        'UV': -18,
        'UW': -7,
        'UX': -10,
        'UZ': -9,
        'U[': -21,
        'U]': -10,
        'U_': -90,
        'Ua': -43,
        'Ub': -7,
        'Uc': -32,
        'Ud': -32,
        'Ue': -32,
        'Uf': -21,
        'Ug': -43,
        'Uh': -7,
        'Ui': -19,
        'Uj': -8,
        'Uk': -7,
        'Ul': -7,
        'Um': -27,
        'Un': -27,
        'Uo': -32,
        'Up': -46,
        'Uq': -32,
        'Ur': -27,
        'Us': -43,
        'Ut': -21,
        'Uu': -32,
        'Uv': -25,
        'Uw': -25,
        'Ux': -35,
        'Uy': -32,
        'Uz': -38,
        'U{': -21,
        'U}': -10,
        'V&': -42,
        'V(': -54,
        'V,': -166,
        'V-': -80,
        'V.': -166,
        'V/': -95,
        'V:': -43,
        'V;': -43,
        'V@': -52,
        'VA': -122,
        'VC': -48,
        'VG': -48,
        'VO': -48,
        'VQ': -48,
        'VS': -21,
        'VU': -10,
        'VZ': -10,
        'V[': -54,
        'V\\': 13,
        'V_': -171,
        'Va': -86,
        'Vb': -5,
        'Vc': -79,
        'Vd': -79,
        'Ve': -79,
        'Vf': -54,
        'Vg': -90,
        'Vh': -5,
        'Vi': -30,
        'Vj': -21,
        'Vk': -5,
        'Vl': -5,
        'Vm': -63,
        'Vn': -63,
        'Vo': -79,
        'Vp': -78,
        'Vq': -79,
        'Vr': -63,
        'Vs': -92,
        'Vt': -32,
        'Vu': -65,
        'Vv': -43,
        'Vw': -43,
        'Vx': -76,
        'Vy': -65,
        'Vz': -68,
        'V{': -54,
        'W&': -33,
        'W(': -43,
        'W,': -133,
        'W-': -70,
        'W.': -133,
        'W/': -97,
        'W:': -43,
        'W;': -43,
        'W@': -52,
        'WA': -114,
        'WC': -41,
        'WG': -41,
        'WM': -7,
        'WN': -7,
        'WO': -41,
        'WQ': -41,
        'WS': -21,
        'WU': -10,
        'WZ': -10,
        'W[': -43,
        'W\\': 13,
        'W_': -142,
        'Wa': -79,
        'Wb': -5,
        'Wc': -81,
        'Wd': -81,
        'We': -81,
        'Wf': -43,
        'Wg': -90,
        'Wh': -5,
        'Wi': -21,
        'Wj': -21,
        'Wk': -5,
        'Wl': -5,
        'Wm': -54,
        'Wn': -54,
        'Wo': -81,
        'Wp': -76,
        'Wq': -81,
        'Wr': -54,
        'Ws': -78,
        'Wt': -28,
        'Wu': -59,
        'Wv': -46,
        'Ww': -46,
        'Wx': -59,
        'Wy': -46,
        'Wz': -68,
        'W{': -43,
        'X(': -21,
        'X*': -7,
        'X-': -46,
        'X:': -7,
        'X;': -7,
        'XC': -32,
        'XG': -32,
        'XO': -32,
        'XQ': -32,
        'XT': -10,
        'XU': -10,
        'XZ': 7,
        'X[': -21,
        'Xa': -3,
        'Xc': -33,
        'Xd': -33,
        'Xe': -33,
        'Xj': -16,
        'Xo': -33,
        'Xp': -34,
        'Xq': -33,
        'Xs': -10,
        'Xt': -32,
        'Xu': -43,
        'Xv': -70,
        'Xw': -70,
        'Xy': -52,
        'X{': -21,
        'Y&': -41,
        'Y(': -54,
        'Y,': -113,
        'Y-': -86,
        'Y.': -113,
        'Y/': -97,
        'Y:': -65,
        'Y;': -65,
        'Y@': -52,
        'YA': -96,
        'YC': -54,
        'YG': -54,
        'YO': -54,
        'YQ': -54,
        'YS': -43,
        'Y[': -54,
        'Y\\': 14,
        'Y_': -119,
        'Ya': -84,
        'Yb': -5,
        'Yc': -100,
        'Yd': -100,
        'Ye': -100,
        'Yf': -65,
        'Yg': -104,
        'Yh': -5,
        'Yi': -43,
        'Yj': -27,
        'Yk': -5,
        'Yl': -5,
        'Ym': -72,
        'Yn': -72,
        'Yo': -100,
        'Yp': -97,
        'Yq': -100,
        'Yr': -72,
        'Ys': -89,
        'Yt': -65,
        'Yu': -89,
        'Yv': -76,
        'Yw': -76,
        'Yx': -68,
        'Yy': -76,
        'Yz': -92,
        'Y{': -54,
        'Z@': 5,
        'ZC': -7,
        'ZG': -7,
        'ZO': -7,
        'ZQ': -7,
        'ZT': -10,
        'ZU': -20,
        'ZV': -10,
        'ZW': -10,
        'ZY': -10,
        'Zp': -10,
        'Zu': -14,
        'Zv': -27,
        'Zw': -27,
        'Zy': -27,
        '[#': -21,
        '[&': -21,
        '[(': -54,
        '[)': 13,
        '[-': -43,
        '[:': -43,
        '[;': -43,
        '[A': -32,
        '[C': -21,
        '[G': -21,
        '[J': 36,
        '[O': -21,
        '[Q': -21,
        '[S': -10,
        '[U': -10,
        '[[': -54,
        '[]': 13,
        '[c': -30,
        '[d': -30,
        '[e': -30,
        '[f': -5,
        '[j': 106,
        '[m': -16,
        '[n': -16,
        '[o': -30,
        '[q': -30,
        '[r': -16,
        '[s': -21,
        '[t': -10,
        '[u': -23,
        '[v': -21,
        '[w': -21,
        '[x': -10,
        '[y': 16,
        '[z': -10,
        '[{': -54,
        '[}': 13,
        '\\"': -86,
        '\\\'': -86,
        '\\,': 16,
        '\\-': -21,
        '\\.': 16,
        '\\C': -32,
        '\\G': -32,
        '\\J': 76,
        '\\O': -32,
        '\\Q': -32,
        '\\T': -65,
        '\\U': -57,
        '\\V': -103,
        '\\W': -90,
        '\\Y': -86,
        '\\\\': -82,
        '\\g': 5,
        '\\j': 93,
        '\\t': -10,
        '\\u': -5,
        '\\v': -21,
        '\\w': -21,
        '\\y': 32,
        '])': -54,
        '],': -43,
        '].': -43,
        ']A': -31,
        ']T': -21,
        ']U': -21,
        ']V': -53,
        ']W': -43,
        ']X': -21,
        ']Y': -43,
        ']]': -54,
        ']}': -54,
        '_C': -59,
        '_G': -59,
        '_J': 35,
        '_O': -59,
        '_Q': -59,
        '_S': -21,
        '_T': -88,
        '_U': -108,
        '_V': -163,
        '_W': -152,
        '_Y': -119,
        '_a': -16,
        '_c': -54,
        '_d': -54,
        '_e': -54,
        '_o': -54,
        '_p': -23,
        '_q': -54,
        '_s': -19,
        '_t': -54,
        '_u': -51,
        '_v': -79,
        '_w': -79,
        '_y': -64,
        'a"': -67,
        'a\'': -67,
        'a*': -48,
        'a-': -10,
        'a?': -3,
        'aA': 7,
        'aB': -7,
        'aC': -14,
        'aD': -7,
        'aE': -7,
        'aF': -7,
        'aG': -14,
        'aH': -7,
        'aI': -7,
        'aJ': -19,
        'aK': -7,
        'aL': -7,
        'aO': -14,
        'aP': -7,
        'aQ': -14,
        'aR': -7,
        'aT': -59,
        'aU': -55,
        'aV': -105,
        'aW': -97,
        'aY': -86,
        'a\\': -46,
        'ag': -8,
        'am': -4,
        'an': -4,
        'ap': -19,
        'ar': -4,
        'av': -19,
        'aw': -19,
        'ay': -10,
        'b"': -43,
        'b\'': -43,
        'b)': -14,
        'b*': -27,
        'b,': -27,
        'b-': 10,
        'b.': -27,
        'b/': -19,
        'b:': -3,
        'b;': -3,
        'b?': -3,
        'bA': -43,
        'bB': -23,
        'bD': -23,
        'bE': -23,
        'bF': -23,
        'bH': -23,
        'bI': -23,
        'bJ': -25,
        'bK': -23,
        'bL': -23,
        'bM': -8,
        'bN': -8,
        'bP': -23,
        'bR': -23,
        'bS': -7,
        'bT': -65,
        'bU': -41,
        'bV': -81,
        'bW': -70,
        'bX': -21,
        'bY': -81,
        'b\\': -21,
        'b]': -14,
        'b_': -54,
        'bb': -7,
        'bh': -7,
        'bk': -7,
        'bl': -7,
        'bp': -8,
        'bt': -7,
        'bu': -7,
        'bx': -19,
        'by': -10,
        'b}': -14,
        'c"': -5,
        'c\'': -5,
        'c*': -3,
        'c,': -3,
        'c.': -3,
        'cA': -10,
        'cB': -14,
        'cD': -14,
        'cE': -14,
        'cF': -14,
        'cH': -14,
        'cI': -14,
        'cJ': -21,
        'cK': -14,
        'cL': -14,
        'cP': -14,
        'cR': -14,
        'cT': -43,
        'cU': -32,
        'cV': -73,
        'cW': -65,
        'cX': -21,
        'cY': -65,
        'c\\': -5,
        'c_': -27,
        'cb': -10,
        'ch': -10,
        'ck': -10,
        'cl': -10,
        'cp': -10,
        'd"': -23,
        'd&': -13,
        'd\'': -23,
        'd)': -3,
        'd*': -21,
        'd-': -5,
        'd?': -5,
        'dJ': -3,
        'dT': -23,
        'dU': -26,
        'dV': -43,
        'dW': -38,
        'dY': -45,
        'd\\': -5,
        'd]': -3,
        'da': -8,
        'dg': -8,
        'dp': -18,
        'du': -10,
        'dv': -10,
        'dw': -10,
        'dy': -10,
        'd}': -3,
        'e"': -21,
        'e\'': -21,
        'e)': -16,
        'e*': -21,
        'e,': -29,
        'e.': -29,
        'e/': -8,
        'e?': -3,
        'eA': -19,
        'eB': -10,
        'eD': -10,
        'eE': -10,
        'eF': -10,
        'eH': -10,
        'eI': -10,
        'eJ': -21,
        'eK': -10,
        'eL': -10,
        'eP': -10,
        'eR': -10,
        'eT': -52,
        'eU': -32,
        'eV': -71,
        'eW': -63,
        'eX': -21,
        'eY': -77,
        'e\\': -21,
        'e]': -16,
        'e_': -43,
        'ea': -7,
        'eb': -10,
        'ef': -7,
        'eh': -10,
        'ek': -10,
        'el': -10,
        'ep': -8,
        'ev': -7,
        'ew': -7,
        'ey': -7,
        'e}': -16,
        'f!': 41,
        'f"': 84,
        'f\'': 84,
        'f)': 97,
        'f*': 57,
        'f,': -38,
        'f-': -13,
        'f.': -38,
        'f/': -18,
        'f?': 39,
        'fA': -7,
        'fB': 18,
        'fD': 18,
        'fE': 18,
        'fF': 18,
        'fH': 18,
        'fI': 18,
        'fJ': 26,
        'fK': 18,
        'fL': 18,
        'fM': 42,
        'fN': 42,
        'fP': 18,
        'fR': 18,
        'fS': 25,
        'fT': 58,
        'fU': 42,
        'fV': 58,
        'fW': 58,
        'fX': 51,
        'fY': 58,
        'fZ': 42,
        'f\\': 104,
        'f]': 97,
        'f_': -23,
        'fb': -10,
        'fc': -17,
        'fd': -17,
        'fe': -17,
        'fg': -5,
        'fh': -10,
        'fi': 25,
        'fj': 25,
        'fk': -10,
        'fl': -10,
        'fo': -17,
        'fq': -17,
        'fu': -10,
        'fv': 10,
        'fw': 10,
        'fy': 10,
        'f}': 97,
        'g&': -21,
        'g-': -3,
        'g/': 14,
        'g?': -5,
        'gB': -7,
        'gD': -7,
        'gE': -7,
        'gF': -7,
        'gH': -7,
        'gI': -7,
        'gJ': 52,
        'gK': -7,
        'gL': -7,
        'gM': -5,
        'gN': -5,
        'gP': -7,
        'gR': -7,
        'gT': -27,
        'gU': -34,
        'gV': -43,
        'gW': -43,
        'gY': -72,
        'g\\': -16,
        'ga': -19,
        'gb': -13,
        'gc': -8,
        'gd': -8,
        'ge': -8,
        'gg': -8,
        'gh': -13,
        'gj': 20,
        'gk': -13,
        'gl': -13,
        'go': -8,
        'gq': -8,
        'gv': 4,
        'gw': 4,
        'gy': 9,
        'h"': -59,
        'h\'': -59,
        'h)': -14,
        'h*': -72,
        'h?': -7,
        'hB': -5,
        'hC': -3,
        'hD': -5,
        'hE': -5,
        'hF': -5,
        'hG': -3,
        'hH': -5,
        'hI': -5,
        'hJ': -21,
        'hK': -5,
        'hL': -5,
        'hO': -3,
        'hP': -5,
        'hQ': -3,
        'hR': -5,
        'hT': -63,
        'hU': -35,
        'hV': -92,
        'hW': -84,
        'hY': -76,
        'h\\': -54,
        'h]': -14,
        'hp': -15,
        'ht': -4,
        'hu': -4,
        'hv': -27,
        'hw': -27,
        'hy': -27,
        'h}': -14,
        'i!': -5,
        'i"': -7,
        'i&': -5,
        'i\'': -7,
        'i*': -5,
        'i?': -7,
        'iB': -5,
        'iD': -5,
        'iE': -5,
        'iF': -5,
        'iH': -5,
        'iI': -5,
        'iK': -5,
        'iL': -5,
        'iP': -5,
        'iR': -5,
        'iT': -21,
        'iU': -21,
        'iV': -21,
        'iW': -21,
        'iY': -21,
        'ip': -11,
        'iv': -15,
        'iw': -15,
        'iy': -15,
        'j"': -5,
        'j&': -5,
        'j\'': -5,
        'j*': -5,
        'j,': -16,
        'j.': -16,
        'j/': -13,
        'j:': -14,
        'j;': -14,
        'j?': -3,
        'jA': -14,
        'jB': -7,
        'jC': -3,
        'jD': -7,
        'jE': -7,
        'jF': -7,
        'jG': -3,
        'jH': -7,
        'jI': -7,
        'jK': -7,
        'jL': -7,
        'jO': -3,
        'jP': -7,
        'jQ': -3,
        'jR': -7,
        'jU': -26,
        'jV': -18,
        'jW': -18,
        'jX': -10,
        'jY': -21,
        'j_': -35,
        'jb': -3,
        'jg': -10,
        'jh': -3,
        'jk': -3,
        'jl': -3,
        'jp': -3,
        'k)': -10,
        'k*': -3,
        'k-': -21,
        'k:': -3,
        'k;': -3,
        'k?': -5,
        'kA': 16,
        'kB': -5,
        'kC': -4,
        'kD': -5,
        'kE': -5,
        'kF': -5,
        'kG': -4,
        'kH': -5,
        'kI': -5,
        'kJ': -21,
        'kK': -5,
        'kL': -5,
        'kO': -4,
        'kP': -5,
        'kQ': -4,
        'kR': -5,
        'kT': -43,
        'kU': -43,
        'kV': -72,
        'kW': -59,
        'kX': 5,
        'kY': -76,
        'kZ': 8,
        'k\\': -3,
        'k]': -10,
        'kc': -19,
        'kd': -19,
        'ke': -19,
        'ko': -19,
        'kp': -10,
        'kq': -19,
        'ks': -7,
        'k}': -10,
        'l"': -23,
        'l&': -13,
        'l\'': -23,
        'l)': -3,
        'l*': -21,
        'l-': -5,
        'l?': -5,
        'lJ': -3,
        'lT': -23,
        'lU': -26,
        'lV': -43,
        'lW': -38,
        'lY': -45,
        'l\\': -5,
        'l]': -3,
        'la': -8,
        'lg': -8,
        'lp': -18,
        'lu': -10,
        'lv': -10,
        'lw': -10,
        'ly': -10,
        'l}': -3,
        'm"': -59,
        'm\'': -59,
        'm)': -14,
        'm*': -72,
        'm?': -7,
        'mB': -5,
        'mC': -3,
        'mD': -5,
        'mE': -5,
        'mF': -5,
        'mG': -3,
        'mH': -5,
        'mI': -5,
        'mJ': -21,
        'mK': -5,
        'mL': -5,
        'mO': -3,
        'mP': -5,
        'mQ': -3,
        'mR': -5,
        'mT': -63,
        'mU': -35,
        'mV': -92,
        'mW': -84,
        'mY': -76,
        'm\\': -54,
        'm]': -14,
        'mp': -15,
        'mt': -4,
        'mu': -4,
        'mv': -27,
        'mw': -27,
        'my': -27,
        'm}': -14,
        'n"': -59,
        'n\'': -59,
        'n)': -14,
        'n*': -72,
        'n?': -7,
        'nB': -5,
        'nC': -3,
        'nD': -5,
        'nE': -5,
        'nF': -5,
        'nG': -3,
        'nH': -5,
        'nI': -5,
        'nJ': -21,
        'nK': -5,
        'nL': -5,
        'nO': -3,
        'nP': -5,
        'nQ': -3,
        'nR': -5,
        'nT': -63,
        'nU': -35,
        'nV': -92,
        'nW': -84,
        'nY': -76,
        'n\\': -54,
        'n]': -14,
        'np': -15,
        'nt': -4,
        'nu': -4,
        'nv': -27,
        'nw': -27,
        'ny': -27,
        'n}': -14,
        'o"': -43,
        'o\'': -43,
        'o)': -14,
        'o*': -27,
        'o,': -27,
        'o-': 10,
        'o.': -27,
        'o/': -19,
        'o:': -3,
        'o;': -3,
        'o?': -3,
        'oA': -43,
        'oB': -23,
        'oD': -23,
        'oE': -23,
        'oF': -23,
        'oH': -23,
        'oI': -23,
        'oJ': -25,
        'oK': -23,
        'oL': -23,
        'oM': -8,
        'oN': -8,
        'oP': -23,
        'oR': -23,
        'oS': -7,
        'oT': -65,
        'oU': -41,
        'oV': -81,
        'oW': -70,
        'oX': -21,
        'oY': -81,
        'o\\': -21,
        'o]': -14,
        'o_': -54,
        'ob': -7,
        'oh': -7,
        'ok': -7,
        'ol': -7,
        'op': -8,
        'ot': -7,
        'ou': -7,
        'ox': -19,
        'oy': -10,
        'o}': -14,
        'p"': -43,
        'p\'': -43,
        'p)': -14,
        'p*': -27,
        'p,': -27,
        'p-': 10,
        'p.': -27,
        'p/': -19,
        'p:': -3,
        'p;': -3,
        'p?': -3,
        'pA': -43,
        'pB': -23,
        'pD': -23,
        'pE': -23,
        'pF': -23,
        'pH': -23,
        'pI': -23,
        'pJ': -25,
        'pK': -23,
        'pL': -23,
        'pM': -8,
        'pN': -8,
        'pP': -23,
        'pR': -23,
        'pS': -7,
        'pT': -65,
        'pU': -41,
        'pV': -81,
        'pW': -70,
        'pX': -21,
        'pY': -81,
        'p\\': -21,
        'p]': -14,
        'p_': -54,
        'pb': -7,
        'ph': -7,
        'pk': -7,
        'pl': -7,
        'pp': -8,
        'pt': -7,
        'pu': -7,
        'px': -19,
        'py': -10,
        'p}': -14,
        'q"': -25,
        'q&': -3,
        'q\'': -25,
        'q)': 10,
        'q*': -23,
        'q,': 32,
        'q.': 13,
        'q/': 10,
        'q;': 33,
        'q?': -3,
        'qA': -14,
        'qB': -23,
        'qD': -23,
        'qE': -23,
        'qF': -23,
        'qH': -23,
        'qI': -23,
        'qJ': 33,
        'qK': -23,
        'qL': -23,
        'qM': -16,
        'qN': -16,
        'qP': -23,
        'qR': -23,
        'qT': -54,
        'qU': -45,
        'qV': -86,
        'qW': -72,
        'qX': -5,
        'qY': -86,
        'q\\': -14,
        'q]': 10,
        'q_': -3,
        'qa': -8,
        'qb': -7,
        'qh': -7,
        'qj': 39,
        'qk': -7,
        'ql': -7,
        'qy': 19,
        'q}': 10,
        'r"': 5,
        'r&': -11,
        'r\'': 5,
        'r)': -25,
        'r*': 16,
        'r,': -93,
        'r-': -32,
        'r.': -93,
        'r/': -52,
        'r:': -8,
        'r;': -8,
        'r?': -5,
        'r@': -13,
        'rA': -60,
        'rB': -25,
        'rD': -25,
        'rE': -25,
        'rF': -25,
        'rH': -25,
        'rI': -25,
        'rJ': -30,
        'rK': -25,
        'rL': -25,
        'rM': -16,
        'rN': -16,
        'rP': -25,
        'rR': -25,
        'rT': -5,
        'rU': -30,
        'rV': -51,
        'rW': -43,
        'rX': -59,
        'rY': -52,
        'r]': -25,
        'r_': -71,
        'ra': -10,
        'rb': -10,
        'rc': -14,
        'rd': -14,
        're': -14,
        'rg': -14,
        'rh': -10,
        'rk': -10,
        'rl': -10,
        'ro': -14,
        'rq': -14,
        'rs': -8,
        'rt': 18,
        'rv': 10,
        'rw': 10,
        'ry': 10,
        'r}': -25,
        's"': -21,
        's\'': -21,
        's)': -14,
        's*': -14,
        's,': -23,
        's.': -23,
        'sA': -10,
        'sB': -21,
        'sD': -21,
        'sE': -21,
        'sF': -21,
        'sH': -21,
        'sI': -21,
        'sJ': -27,
        'sK': -21,
        'sL': -21,
        'sM': -10,
        'sN': -10,
        'sP': -21,
        'sR': -21,
        'sT': -35,
        'sU': -25,
        'sV': -76,
        'sW': -65,
        'sY': -94,
        's\\': -25,
        's]': -14,
        's_': -41,
        'sb': -10,
        'sf': -4,
        'sh': -10,
        'sk': -10,
        'sl': -10,
        'sp': -9,
        's}': -14,
        't"': 5,
        't\'': 5,
        't-': -10,
        'tA': 16,
        'tJ': -10,
        'tU': -13,
        'tV': -43,
        'tW': -32,
        'tY': -48,
        'tZ': 7,
        't_': 13,
        'tt': 7,
        'tv': 8,
        'tw': 8,
        'u"': -40,
        'u\'': -40,
        'u)': -23,
        'u*': -38,
        'u:': -10,
        'u;': -10,
        'uC': -13,
        'uG': -13,
        'uJ': -29,
        'uO': -13,
        'uQ': -13,
        'uT': -41,
        'uU': -40,
        'uV': -83,
        'uW': -76,
        'uY': -78,
        'u\\': -21,
        'u]': -23,
        'uc': -7,
        'ud': -7,
        'ue': -7,
        'ug': -10,
        'uj': -7,
        'uo': -7,
        'up': -11,
        'uq': -7,
        'uv': -21,
        'uw': -21,
        'uy': -21,
        'u}': -23,
        'v"': -3,
        'v&': -17,
        'v\'': -3,
        'v)': -36,
        'v*': -3,
        'v,': -101,
        'v-': -14,
        'v.': -101,
        'v/': -43,
        'v:': -3,
        'v;': -3,
        'v?': -5,
        'v@': -8,
        'vA': -71,
        'vB': -27,
        'vD': -27,
        'vE': -27,
        'vF': -27,
        'vH': -27,
        'vI': -27,
        'vJ': -41,
        'vK': -27,
        'vL': -27,
        'vM': -21,
        'vN': -21,
        'vP': -27,
        'vR': -27,
        'vT': -14,
        'vU': -25,
        'vV': -54,
        'vW': -45,
        'vX': -54,
        'vY': -59,
        'vZ': -6,
        'v]': -36,
        'v_': -84,
        'va': -15,
        'vb': -23,
        'vc': -19,
        'vd': -19,
        've': -19,
        'vg': -19,
        'vh': -23,
        'vk': -23,
        'vl': -23,
        'vo': -19,
        'vq': -19,
        'vs': -9,
        'vt': 7,
        'vv': 11,
        'vw': 11,
        'vy': 11,
        'v}': -36,
        'w"': -3,
        'w&': -17,
        'w\'': -3,
        'w)': -36,
        'w*': -3,
        'w,': -101,
        'w-': -14,
        'w.': -101,
        'w/': -43,
        'w:': -3,
        'w;': -3,
        'w?': -5,
        'w@': -8,
        'wA': -71,
        'wB': -27,
        'wD': -27,
        'wE': -27,
        'wF': -27,
        'wH': -27,
        'wI': -27,
        'wJ': -41,
        'wK': -27,
        'wL': -27,
        'wM': -21,
        'wN': -21,
        'wP': -27,
        'wR': -27,
        'wT': -14,
        'wU': -25,
        'wV': -54,
        'wW': -45,
        'wX': -54,
        'wY': -59,
        'wZ': -6,
        'w]': -36,
        'w_': -84,
        'wa': -15,
        'wb': -23,
        'wc': -19,
        'wd': -19,
        'we': -19,
        'wg': -19,
        'wh': -23,
        'wk': -23,
        'wl': -23,
        'wo': -19,
        'wq': -19,
        'ws': -9,
        'wt': 7,
        'wv': 11,
        'ww': 11,
        'wy': 11,
        'w}': -36,
        'x)': -14,
        'x-': -25,
        'xA': 7,
        'xC': -8,
        'xG': -8,
        'xJ': -19,
        'xO': -8,
        'xQ': -8,
        'xT': -30,
        'xU': -32,
        'xV': -76,
        'xW': -54,
        'xY': -68,
        'x]': -14,
        'xa': -11,
        'xc': -19,
        'xd': -19,
        'xe': -19,
        'xg': -8,
        'xo': -19,
        'xp': -19,
        'xq': -19,
        'xx': 5,
        'x}': -14,
        'y"': -3,
        'y&': -17,
        'y\'': -3,
        'y)': -36,
        'y*': -3,
        'y,': -101,
        'y-': -14,
        'y.': -101,
        'y/': -43,
        'y:': -3,
        'y;': -3,
        'y?': -5,
        'y@': -8,
        'yA': -71,
        'yB': -27,
        'yD': -27,
        'yE': -27,
        'yF': -27,
        'yH': -27,
        'yI': -27,
        'yJ': -41,
        'yK': -27,
        'yL': -27,
        'yM': -21,
        'yN': -21,
        'yP': -27,
        'yR': -27,
        'yT': -14,
        'yU': -25,
        'yV': -54,
        'yW': -45,
        'yX': -54,
        'yY': -59,
        'yZ': -6,
        'y]': -36,
        'y_': -84,
        'ya': -15,
        'yb': -23,
        'yc': -19,
        'yd': -19,
        'ye': -19,
        'yg': -19,
        'yh': -23,
        'yk': -23,
        'yl': -23,
        'yo': -19,
        'yq': -19,
        'ys': -9,
        'yt': 7,
        'yv': 11,
        'yw': 11,
        'yy': 11,
        'y}': -36,
        'z)': -10,
        'z*': -5,
        'zT': -16,
        'zU': -27,
        'zV': -65,
        'zW': -56,
        'zY': -61,
        'z]': -10,
        'zp': -8,
        'z}': -10,
        '{#': -21,
        '{&': -21,
        '{(': -54,
        '{)': 13,
        '{-': -43,
        '{:': -43,
        '{;': -43,
        '{A': -32,
        '{C': -21,
        '{G': -21,
        '{J': 36,
        '{O': -21,
        '{Q': -21,
        '{S': -10,
        '{U': -10,
        '{[': -54,
        '{]': 13,
        '{c': -30,
        '{d': -30,
        '{e': -30,
        '{f': -5,
        '{j': 106,
        '{m': -16,
        '{n': -16,
        '{o': -30,
        '{q': -30,
        '{r': -16,
        '{s': -21,
        '{t': -10,
        '{u': -23,
        '{v': -21,
        '{w': -21,
        '{x': -10,
        '{y': 16,
        '{z': -10,
        '{{': -54,
        '{}': 13,
        '})': -54,
        '},': -43,
        '}.': -43,
        '}A': -31,
        '}T': -21,
        '}U': -21,
        '}V': -53,
        '}W': -43,
        '}X': -21,
        '}Y': -43,
        '}]': -54,
        '}}': -54,
    },
};
